/** @format */

import { skipToken } from "@reduxjs/toolkit/dist/query";
import React from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { useGetUserResourceLessonQuery } from "../../app/services/userResource/userLessonApi";
import { useLocale } from "../i18n/hooks";
import LessonPageUI from "./LessonPageUI";
import { UserResource } from "../resources/types";
import { UuidString } from "../userResources/userResourceFunctions";
import PageNotFound from "../pageNotFound/PageNotFound";
import BLSpinner from "../../assets/animations/BLSpinner/BLSpinner";
import { getResourceCode } from "../../utils/GetResourceCode";

const UserResourceLessonPage: React.FC = () => {
  const resource: UserResource = useOutletContext();

  const resourceId = resource !== null ? getResourceCode(resource) : undefined;
  const { lessonId, copy, userId } = useParams();
  const locale = useLocale();

  const lessonIndex = Number(lessonId);

  const { data: lesson, isFetching: isFetchingLesson } =
    useGetUserResourceLessonQuery(
      !!resourceId && !!userId && !!copy
        ? { code: resourceId, locale, copy, email: userId, lessonIndex }
        : skipToken,
    );

  return (
    <>
      {isFetchingLesson ? (
        <BLSpinner
          className="position-absolute top-50 start-50 translate-middle"
          size="3rem"
        />
      ) : lesson ? (
        <LessonPageUI
          resourceId={resourceId}
          resourceUUID={resource.UUID as UuidString}
          lesson={lesson}
        />
      ) : (
        <PageNotFound itemName={"Lesson"} />
      )}
    </>
  );
};

export default UserResourceLessonPage;
